export enum TaxIdSignatureType {
  NONE,
  CI,
  RUC,
}
